import { render, staticRenderFns } from "./SaveWawa.vue?vue&type=template&id=9d422866&scoped=true&"
import script from "./SaveWawa.vue?vue&type=script&lang=js&"
export * from "./SaveWawa.vue?vue&type=script&lang=js&"
import style0 from "./SaveWawa.vue?vue&type=style&index=0&id=9d422866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d422866",
  null
  
)

component.options.__file = "SaveWawa.vue"
export default component.exports